<template>
  <div class="home">
    <div class="caption">
      <div class="container">
        <div class="caption-content">
          <p class="caption-content__desc">商品全链路流通和销售平台</p>
          <ul class="caption-content__hot">
            <li>✓ 更宽广的分销渠道</li>
            <li>✓ 众多知名品牌商的信赖之选</li>
            <li>✓ 为企业量身定制的电商解决方案</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <h4 class="section-desc">数百位管家分销您的好货，触及百万消费者</h4>
        <ul class="section-props">
          <li>
            <img src="@/assets/images/icon_circle_trunk.png" alt="">
            <h6>商品快速流通</h6>
            <p>商品管理、订单发货、物流跟踪、
资金结算 一站式处理</p>
          </li>
          <li>
            <img src="@/assets/images/icon_circle_price.png" alt="">
            <h6>价格管控</h6>
            <p>控制商品成本、限定零售价范围，
保证品牌市场价值</p>
          </li>
          <li>
            <img src="@/assets/images/icon_circle_shop.png" alt="">
            <h6>多渠道分销</h6>
            <p>有经营能力的分销商、个人小微店主、
管家等，开启分销新渠道</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  .caption {
    height: 300px;
    background: #fff url('~@/assets/images/banner.jpg') center center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    &-content {
      color: #fff;
      padding: 0 10px;
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
      &__title {
        font-size: 32px;
        line-height: 32px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      &__desc {
        font-size: 20px;
        margin-bottom: 10px;
      }
      &__hot {
        font-weight: bold;
        li {
          margin-bottom: 6px;
          font-size: 14px;
        }
      }
    }
  }
  .section {
    padding: 64px 0;
    &-title{
      text-align: center;
      font-size: 26px;
      line-height: 1.6;
      color: #ff4d2f;
    }
    &-desc {
      font-size: 14px;
      color: #333;
      line-height: 1.4;
      text-align: center;
      margin-bottom: 50px;
      margin-top: 10px;
    }
    &-props {
      border-top: 1px solid #ddd;
      margin-top: 50px;
      padding-top: 50px;
      li {
        text-align: center;
        padding: 30px;
        img {
          width: 65px;
          height: 65px;
          display: block;
          margin: 0 auto 20px;
        }
        h6 {
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #333;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
  @media screen and (min-width: 768px) {
    .caption {
      height: 420px;
      &-content {
        &__title {
          font-size: 41px;
          line-height: 41px;
        }
        &__desc {
          font-size: 24px;
          margin-bottom: 30px;
        }
        &__hot {
          li {
            font-size: 18px;
          }
        }
      }
    }
    .section {
      &-props {
        display: flex;
        li {
          flex: 1;
          padding: 0 30px;
        }
      }
    }
  }
</style>
